import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppConfigService } from '../../services/config/app-config.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SettlementServiceService } from '../../services/raintree/Transmission/settlement-service.service';
import { ShowBankStatementDialogComponent } from './show-bank-statement-dialog/show-bank-statement-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { SettlementFilterDialogComponent } from './settlement-filter-dialog/settlement-filter-dialog.component';

@Component({
  selector: 'app-settlement-view',
  standalone: true,
  imports: [LoaderComponent, CommonModule, MatIconModule, MatOptionModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
  templateUrl: './settlement-view.component.html',
  styleUrls: ['./settlement-view.component.scss', '../../../styles/_dropdown.scss']
})
export class SettlementViewComponent {
  breadcrumbs: any[] = ['INDIA']
  country: string = 'India';
  dropArr = [{ value: 'Unsettle Region Wise', id: 'unsettledRegionWise' }]
  regionWise = new FormControl(this.dropArr[0].id)
  selectedReportType: string = 'Unsettled Region Wise'
  options: any[] = [];
  filteredRows: any = [];
  bankWiseReports: any = [];
  todayDate: string = '';
  columnConfs: any = {
    actions: {
      cssClass: 'text-align-right',
    },
  };
  bankWiseColumnConfs: any = {
    totalAmount: {
      cssClass: 'text-align-right',
    },
  };
  maxDate = new Date().toISOString().split('T')[0];
  dateSelect: FormControl = new FormControl('');
  reportViewControl: FormControl = new FormControl();
  isLoading: boolean = false;
  value: any;
  subViews: any[] = [];
  selectedLotId: string = ''; // all selected lot id
  selectedLotUUId: string = '';
  totalSlips: number = 0;
  lotTotal: number = 0;
  slipsEntered: number = 0;
  slipsTotal: number = 0;
  selectedLotData: any;
  stateData: any = {};
  currentFilter: any = {
    startDate: '2025-04-01',
    endDate: '2026-03-31',
    bankId: ''
  };

  constructor(
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private appConfig: AppConfigService,
    private bankService: SettlementServiceService,
    private dialog: MatDialog
  ) { }
  ngOnInit(): void {
    this.getBankStatementReports(this.regionWise?.value)
  }

  // onBreadcrumbClick(index?: any) {
  //   this.isLoading = true
  //   // if(index>=1){
  //   this.breadcrumbs.splice(index + 1)
  //   this.removeBreadCrumbs(true)
  //   // }
  // }

  // removeBreadCrumbs(type: boolean) {
  //   let queryParams = { ...this.route.snapshot.queryParams };
  //   if (type) {
  //     if (this.breadcrumbs.length === 1) {
  //       localStorage.setItem('delete-state', '')
  //       localStorage.setItem('delete-district', '')
  //       delete queryParams['district'];
  //       delete queryParams['state'];
  //       delete queryParams['country'];
  //       delete queryParams['pincode'];
  //       delete queryParams['year']
  //     }
  //     else if (this.breadcrumbs.length === 2) {
  //       localStorage.setItem('delete-state', '')
  //       localStorage.setItem('delete-district', '')
  //       delete queryParams['state'];
  //       delete queryParams['district'];
  //       delete queryParams['pincode'];
  //     }
  //     else if (this.breadcrumbs.length === 4) {
  //       delete queryParams['pincode'];
  //     }
  //     else {
  //       localStorage.setItem('delete-district', '')
  //       delete queryParams['district'];
  //       delete queryParams['pincode'];
  //     }
  //     this.router.navigate([], {
  //       relativeTo: this.route,
  //       queryParams: queryParams,
  //     });
  //   } else {
  //     this.route.queryParams.subscribe((params) => {
  //       if (Object.keys(params).length === 0 && this.breadcrumbs.length > 1) {
  //         this.breadcrumbs = ['All countries']
  //       }
  //     });
  //   }
  // }

  // handleBreadCrumbClick(index: number) {
  //   const selected = this.breadcrumbs[index];
  //   this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
  //   if (this.selectedLotId) this.selectedLotId = '';
  //   this.router.navigate([], {
  //     relativeTo: this.route,
  //     // queryParams: { selected },
  //     queryParamsHandling: '',
  //   });
  // }
  // getSubViewName(viewId: number) {
  //   return this.options.find((item) => item.id == viewId)?.title;
  // }

  // onClickedCounterStats(lotData: any) {
  //   console.log('event', lotData);
  //   this.selectedLotData = lotData;
  //   this.selectedLotId = lotData.LotId;
  //   this.selectedLotUUId = lotData.lotUUId;
  //   this.totalSlips = lotData.slipCount;
  //   this.lotTotal = lotData.totalAmount;
  //   this.getLotSummary(lotData.lotUUId);
  // }

  // getLotSummary(lotUUID: string) {
  //   // this.philMemberService.getLotSummary(lotUUID).subscribe({
  //   //   next: (response: any) => {
  //   //     if (!response.error) {
  //   //       this.slipsEntered = Number(response?.data[0].lotSlipsDone) ?? 0;
  //   //       this.slipsTotal = Number(response?.data[0].lotAmountDone) ?? 0;
  //   //       this.breadcrumbs.push(`Lot ID - ${this.selectedLotId}`);
  //   //     }
  //   //   },
  //   // });
  // }


  // bank view ts 

  selectedState: string = ''
  selectedDistrict: string = ''
  displayedColumnsRegionWise: any = []

  onClickBreadcrumb(selectedBreadcrumb: string) {
    // console.log(selectedBreadcrumb);


    const index = this.breadcrumbs.indexOf(selectedBreadcrumb);
    if (index === -1) {
      this.breadcrumbs = [];
      return;
    }

    this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
    console.log('Selected Bradcrumb', selectedBreadcrumb, this.breadcrumbs);

    if (this.breadcrumbs.length == 2) {
      const state = this.breadcrumbs[1];
      this.breadcrumbs = ['INDIA'];
      this.onClickState(state);
      // this.selectedDistrict = ''
    }

    if (this.breadcrumbs.length == 1 && this.breadcrumbs.includes('INDIA')) {
      this.getBankStatementReports('unsettledRegionWise');
      this.selectedState = '';
    }
  }

  onClickState(state: string) {
    //console.log('SELECTED STATE', state);
    this.selectedState = state;
    this.selectedDistrict = '';
    this.breadcrumbs = ['INDIA']
    if (!this.breadcrumbs.includes(state))
      this.breadcrumbs.push(state)
    this.displayedColumnsRegionWise = [
      {
        name: 'State',
        id: 'state'
      },
      {
        name: 'District',
        id: 'district'
      },
      {
        name: 'Unsettled Count',
        id: 'unsettled'
      }
    ]
    this.getBankStatementReports('unsettledRegionWise', state);
  }

  onClickDistrict(district: string) {
    //console.log('SELECTED DISTRICT', district);
    this.selectedDistrict = district;
    if (!this.breadcrumbs.includes(district))
      this.breadcrumbs.push(district)
    this.getBankStatementReports('unsettledRegionWise', this.selectedState, district);
  }

  getBankStatementReports(reportType: any, state?: string | null, district?: string | null) {
    this.isLoading = true
    const queryParams: any = {
      reportType: reportType,
      startDate: this.currentFilter.startDate,
      endDate: this.currentFilter.endDate,
      bankId: this.currentFilter.bankId || ''
    }
    if (state)
      queryParams.uiState = state;

    if (district)
      queryParams.uiDistrict = district;

    this.bankService.getBankStatistics(queryParams).subscribe({
      next: (res) => {
        this.isLoading = false
        this.stateData = res.data

      },
      error: (err) => {
        this.isLoading = false
        this.toaster.error(err.message)
      }
    })
  }

  getIndianFinancialYearRangeIST(
    date: moment.Moment = moment(),
    timeZone: string = 'Asia/Kolkata'
  ) {
    const istDate = date.clone().tz(timeZone);

    const year = istDate.year();
    const month = istDate.month(); // 0 = Jan, 3 = April

    let startDate: moment.Moment;
    let endDate: moment.Moment;

    if (month >= 3) {
      // April–December → current year
      startDate = moment.tz(`${year}-04-01 00:00:00`, timeZone);
      endDate = moment.tz(`${year + 1}-03-31 23:59:59`, timeZone);
    } else {
      // Jan–March → previous year
      startDate = moment.tz(`${year - 1}-04-01 00:00:00`, timeZone);
      endDate = moment.tz(`${year}-03-31 23:59:59`, timeZone);
    }

    return {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    };
  }



  getBankStatement(bankStatement: any) {
    //console.log('BANK STATEMENT', bankStatement, this.currentFilter);
    const { startDate, endDate } = this.getIndianFinancialYearRangeIST();

    const payload = {
      startDate: this.currentFilter?.startDate?.length ? this.currentFilter.startDate : startDate,
      endDate: this.currentFilter?.endDate?.length ? this.currentFilter.endDate : endDate,
      bankId: this.currentFilter.bankId ?? '',
      uiState: bankStatement?.state ?? '',
      uiDistrict: bankStatement?.district ?? '',
      pincode: bankStatement?.pincode ?? '',
      // centerCode: ''
    }

    const dialogRef = this.dialog.open(ShowBankStatementDialogComponent, {
      //width: '620px',
      panelClass: 'custom-dialog-container',
      data: payload,
      disableClose: true
    });
  }

  getReportType(type: string) {
    return type.trim().toLowerCase().replace(/\s+wise$/, 'Wise').replace(/\s+(\w)/g, (_, c) => c.toUpperCase());
  }

  onClickFilter() {
    const dialogRef = this.dialog.open(SettlementFilterDialogComponent, {
      width: '620px',
      panelClass: 'custom-dialog-container',
      data: this.currentFilter,
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result)
        return;
      if (Object.keys(result).length) {
        this.currentFilter = result;
      } else {
        this.currentFilter = {
          startDate: '',
          endDate: '',
          bankId: ''
        }
      }
      this.getBankStatementReports(this.getReportType(this.selectedReportType), this.selectedState, this.selectedDistrict);
    })
  }


}
